import { angular, app } from '../app.module'
app.controller('CategoryCtrl', ($rootScope, $scope, $state, $filter, CategoryService) => {
  // 管理者権限が無い場合、投稿にリダイレクト
  if ($rootScope.isAdmin === false) {
    $state.go('post')
  }

  // テーブルクエリ設定
  $scope.query = {
    limit: 25,
    options: [10, 25, 50],
    page: 1,
  }
  // md-row-select 用の選択状態
  $scope.selected = []
  $scope.order = ['categoryName', 'subSortNo']

  /**
   * ソート用に値を変更
   * @param  {string} sortText
   * @return {string} ソート用の値
   */
  function changeSortValue(sortText: string) {
    const sortArray = sortText.split('-')
    if (sortArray.length === 1) {
      return '-' + sortText
    } else {
      return sortArray[1]
    }
  }

  /**
   * onPaginate ページングを移動するイベント
   */
  $scope.onPaginate = function () {
    angular.element('body').scrollTop(80)
  }

  /**
   * onReorder ソートのイベント
   * @param  {any} order
   */
  $scope.onReorder = function (order) {
    if ($scope.order[0] === '') {
      $scope.order[0] = '-categoryName'
    }

    if ($scope.order[1] === '') {
      $scope.order[1] = '-subSortNo'
    }

    // ソート番号をソート
    if (order === 'subSortNo' || order === '-subSortNo') {
      $scope.order = [$scope.order[0], changeSortValue($scope.order[1])]
    } else if ($scope.order[0].match(order) !== null) {
      // ソート番号のソート以外 AND ソートタイプの変更(desc or asc)
      $scope.order = [changeSortValue($scope.order[0]), $scope.order[1]]
    } else {
      // ソート番号のソート以外 AND 対象ソートの変更
      $scope.order = [order, $scope.order[1]]
    }
    $scope.sortCategories = $filter('orderBy')($scope.sortCategories, $scope.order)
    // ページングを初期化
    $scope.query.page = 1
  }

  /**
   * getCategoriesList カテゴリ一覧(大カテゴリ・小カテゴリ)の取得
   */
  function getCategoriesList() {
    CategoryService.CategoryData.getCategoriesList().then((categories) => {
      $scope.allCategories = categories
      // フィルタリング
      $scope.filterCategory(categories)
    })
  }

  // ディレクティブから'changeCategoriesList'を受信した場合
  $rootScope.$on('changeCategoriesList', () => {
    getCategoriesList()
    // 業種フォームのカテゴリ一覧を変更
    $rootScope.$broadcast('changeListBrandCategory')
  })

  // カテゴリが変更された場合の処理
  $scope.$on('changeBrandCategory', (event, categoryInfo) => {
    if (categoryInfo.type !== 'category') {
      return
    }
    // 選択したメインカテゴリ、サブカテゴリをセット
    $scope.categoryName = null
    $scope.subCategoryName = null

    // メインカテゴリがある場合、スコープへカテゴリ、サブカテゴリを格納
    if (categoryInfo !== null) {
      $scope.categoryName = categoryInfo.categoryName
      $scope.subCategoryName =
        categoryInfo.subCategoryName !== '指定しない' ? categoryInfo.subCategoryName : null
    }

    // カテゴリ一覧がある場合、フィルタリング
    if ($scope.allCategories !== undefined) {
      $scope.filterCategory($scope.allCategories)
    } else {
      // ロード中フラグ
      $scope.isLoading = true
      // カテゴリ一覧を取得
      getCategoriesList()
    }
  })

  // ディレクティブから、'changeFilterData'を受信した場合
  $scope.$on('changeFilterData', (event, filterInfo) => {
    if (filterInfo.type === 'subCategoryFilter') {
      // カテゴリのサブカテゴリではない場合は、リターン
      if (filterInfo.subCategoryType !== 'category') {
        return
      }
      $scope.subCategoryName = filterInfo.value
    }
    // 小カテゴリフィルタリング
    $scope.filterCategory($scope.allCategories)
  })

  /**
   * カテゴリフィルタリング
   * @param  {{}[]} categories
   */
  $scope.filterCategory = function (categories: {}[]) {
    $scope.sortCategories = $filter('filter')(categories, (category) => {
      // 大カテゴリフィルタリング
      if (
        $scope.categoryName !== null &&
        $scope.categoryName !== '指定しない' &&
        $scope.categoryName !== category.categoryName
      ) {
        return false
      }

      // 小カテゴリフィルタリング
      if (
        $scope.subCategoryName !== null &&
        $scope.subCategoryName !== '指定しない' &&
        $scope.subCategoryName !== category.subCategoryName
      ) {
        return false
      }

      return true
    })
    $scope.sortCategories = $filter('orderBy')($scope.sortCategories, $scope.order)
    $scope.countCategories = $scope.sortCategories.length
    // 取得が完了したら、ロード中フラグを下げる
    $scope.isLoading = false
  }
})
